import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Camera, ArrowLeft, ChevronDown, HelpCircle } from 'lucide-react';

const FAQ = [
  {
    q: 'Como envio um álbum para meu cliente?',
    a: 'Entre no seu painel, clique em "Novo álbum", adicione as fotos/vídeos e copie o link exclusivo gerado. Envie por WhatsApp, e-mail ou onde preferir.'
  },
  {
    q: 'O cliente precisa criar conta para ver as fotos?',
    a: 'Não. O cliente só precisa abrir o link — ele vê as fotos com marca d\'água na hora, sem cadastro.'
  },
  {
    q: 'Como funciona o pagamento?',
    a: 'O cliente seleciona as fotos, escolhe pagar por foto, pacote ou álbum completo. O aplicativo gera um QR Code Pix na hora, com a chave Pix cadastrada no seu perfil.'
  },
  {
    q: 'Onde configuro minha chave Pix?',
    a: 'No painel do fotógrafo, clique no botão "Ajustes" no topo direito e preencha o campo "Chave Pix" (pode ser e-mail, CPF, telefone ou chave aleatória).'
  },
  {
    q: 'A marca d\'água protege 100% as fotos?',
    a: 'Nenhuma marca d\'água online é 100% inviolável, mas o app aplica proteção forte: botão direito, arrastar, print de tela, Ctrl+P e F12 estão bloqueados. Além disso, a marca d\'água diagonal cobre toda a foto até o cliente comprar.'
  },
  {
    q: 'Posso colocar minha logo como marca d\'água?',
    a: 'Sim! No painel > Ajustes > "Logo do estúdio". Suba um PNG (idealmente com fundo transparente) e ele será aplicado automaticamente em todas as fotos e vídeos.'
  },
  {
    q: 'Como o cliente baixa as fotos depois de pagar?',
    a: 'Após confirmar o pagamento, aparece um botão dourado de download em cada foto comprada, além de um botão "Baixar todas" no topo da tela.'
  },
  {
    q: 'Posso enviar vídeos também?',
    a: 'Sim. Na tela de "Adicionar" da galeria você pode arrastar fotos e vídeos (até 20MB cada). Os vídeos também recebem marca d\'água e proteção contra download.'
  },
  {
    q: 'Como instalar o AXSELL como aplicativo?',
    a: 'Na página de login existe o botão "Baixar o aplicativo". Escaneie o QR Code no celular, ou abra o link e siga as instruções (varia entre Android e iPhone).'
  },
  {
    q: 'Esqueci minha senha, como recupero?',
    a: 'A criação e alteração de contas é feita pelo administrador do sistema. Entre em contato pelo WhatsApp ou e-mail de suporte que redefinimos para você.'
  },
  {
    q: 'Tem custo para usar o AXSELL?',
    a: 'O acesso é liberado pelo administrador. Para saber sobre planos e valores, fale com o suporte pelo WhatsApp.'
  },
  {
    q: 'Como o cliente confirma que fez o Pix?',
    a: 'Após pagar no app do banco, ele clica em "Já paguei" no app. Nós recomendamos que você confira o recebimento no seu banco antes de dizer a ele que baixe as fotos.'
  },
];

export default function Help() {
  const [open, setOpen] = useState(0);
  const toggle = (i) => setOpen(open === i ? -1 : i);

  return (
    <div className="grain min-h-screen">
      <header className="border-b border-[#1c1710]">
        <div className="max-w-4xl mx-auto px-6 md:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="brand-mark"><Camera size={16} strokeWidth={2.2} /></span>
            <span className="font-serif text-[20px] text-[#f2ecdf]">AXSELL</span>
          </Link>
          <Link to="/" className="text-[#a89e87] hover:text-[#e6dcc7] inline-flex items-center gap-1.5 text-sm">
            <ArrowLeft size={16} /> Início
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 md:px-8 py-10 md:py-14">
        <div className="mb-10 md:mb-14">
          <div className="text-xs uppercase tracking-[0.14em] text-[#a89e87] flex items-center gap-2">
            <HelpCircle size={14} className="gold-text" /> Central de Ajuda
          </div>
          <h1 className="font-serif text-4xl md:text-5xl text-[#f2ecdf] mt-2">Perguntas frequentes</h1>
          <p className="text-sm text-[#a89e87] mt-3 max-w-2xl">
            Encontre respostas rápidas sobre como usar o AXSELL.
          </p>
        </div>

        <div className="space-y-3">
          {FAQ.map((item, i) => (
            <div
              key={i}
              className={`card-glow rounded-xl transition-all ${open === i ? 'border-[#d6af6c]/30' : ''}`}
            >
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-5 md:px-6 py-4 md:py-5 flex items-center justify-between gap-4"
              >
                <span className="font-medium text-[#f2ecdf] text-sm md:text-base">{item.q}</span>
                <ChevronDown
                  size={18}
                  className={`text-[#a89e87] flex-shrink-0 transition-transform ${open === i ? 'rotate-180 text-[#d6af6c]' : ''}`}
                />
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-[#c4bba5] leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FAQ apenas — canais de suporte removidos a pedido do dono. */}
      </main> {/* ===== INÍCIO DO SUPORTE WHATSAPP ===== */}
<div className="mt-8">
  <h2 className="text-xl font-semibold mb-4">
    Fale com o suporte
  </h2>

  <div className="grid gap-3 sm:grid-cols-2">

    <a
      href="https://wa.me/553299455084"
      target="_blank"
      rel="noopener noreferrer"
      className="p-4 border rounded-lg hover:opacity-80"
    >

    </a>

    <a
      href=""
      target="_blank"
      rel="noopener noreferrer"
      className="p-4 border rounded-lg hover:opacity-80"
    >
    
    </a>

    <a
      href=""
      target="_blank"
      rel="noopener noreferrer"
      className="p-4 border rounded-lg hover:opacity-80"
    >
      💬 Suporte 2 — Keila
    </a>

    <a
      href="https://wa.me/5532998545736"
      target="_blank"
      rel="noopener noreferrer"
      className="p-4 border rounded-lg hover:opacity-80"
    >
      💬 Suporte 1 — Rogério
    </a>

  </div>
</div>
{/* ===== FIM DO SUPORTE WHATSAPP ===== */}
    </div>
  );
}
